import Home from '../DashBoard/Home'
import Fct from '../Components/Fct'
import Crashes from '../Components/Crashes'
import QaDevices from '../Components/QaDevices'
import Unlock from '../Components/Unlock'

const routes = [
    {
        id: 1,
        path: "/home",
        name: "Home",
        element: <Home/>
    },
    {
        id: 2,
        path: "/fct",
        name: "FCT",
        element: <Fct/>
    },
    {
        id: 3,
        path: "/crashes",
        name: "Crashes",
        element: <Crashes/>
    },
    {
        id: 4,
        path: "/qa-devices",
        name: "QA devices",
        element: <QaDevices/>
    },
    {
        id: 5,
        path: "/unlock",
        name: "Unlock unit",
        element: <Unlock/>
    }
]

export default routes;